<template>
  <div class="ui attached bordered inverted blue menu">
    <router-link class="item" to="/">
      <img
        class="ui medium image"
        src="@/assets/bl-logo-2015.png"
        alt="BizLibrary Logo"
      />
    </router-link>
    <div class="right menu">
      <div class="item" v-if="canCustomizeContent">
        <button class="ui green button" @click="openCreateContent">
          <i class="bzl-plus icon"></i>
          Create New Content
        </button>
      </div>
      <div id="user-dropdown" class="ui inverted blue dropdown item">
        <div class="item">
          <div
            class="ui mini circular image"
            :style="{ backgroundImage: `url(${userImage})` }"
          ></div>
        </div>
        <span class="capitalized">{{ fullName }}</span>
        <i class="angle down icon"></i>
        <div class="menu">
          <router-link class="item" :to="{ name: 'profile' }"
            >My Profile</router-link
          >
          <router-link class="item" :to="{ name: 'logout' }"
            >Sign Out</router-link
          >
        </div>
      </div>
      <div id="gear-icon" class="ui inverted blue dropdown item">
        <i class="large bzl-gear icon"></i>
        <div class="menu">
          <router-link class="item" :to="{ name: 'my-products' }"
            >My Products</router-link
          >
          <router-link
            v-if="canCustomizeContent"
            :to="{ name: 'authentication' }"
            class="item"
            >Authentication Method</router-link
          >
          <router-link
            v-if="integrationName"
            :to="{ name: 'integrations' }"
            class="item"
            >{{integrationName}} Setup
          </router-link>
          <div class="item" @click="lmsSsoRedirect('lms')">
            Client Resources
          </div>
        </div>
      </div>
      <a class="ui inverted blue icon item clickable" @click="lmsSsoRedirect('help')">
        <i class="large question circle icon"></i>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SSOService from '@/services/api/sso/sso-service';
export default {
  name: 'NavHeader',
  computed: {
    ...mapGetters(['canCustomizeContent', 'integrationName']),
    cognitoInfo() {
      return this.$store.getters.cognitoInfo;
    },
    fullName() {
      return `${this.cognitoInfo.given_name} ${this.cognitoInfo.family_name}`;
    },
    userImage() {
      return this.$store.getters.userImage;
    },
  },
  methods: {
    lmsSsoRedirect(type) {
      // call to API where S3 call for AccessKey and AccessSecret will be obtained via Look matching
      SSOService.getSSOCredentials({ ...this.cognitoInfo, type })
        .then(url => {
          window.open(url, '_blank', 'noopener');
        })
        .catch(err => {
          $('body').toast({
            class: 'error',
            message:
              err || 'Something went wrong. Please refresh and try again.',
          });
        });
    },
    openCreateContent() {
      this.$emit('showModal');
    },
  },
  mounted() {
    this.$store.dispatch('getUserImage');
    $('#user-dropdown').dropdown();
    $('#gear-icon').dropdown();
  },
};
</script>
